import { createRoute } from '@tanstack/react-router';
import { onboarderParentRoute } from 'pages/onboarder/onboarderParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const onboarderPharmacyEditRoute = createRoute({
  getParentRoute: () => onboarderParentRoute,
  path: '/pharmacies/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/onboarder/OnboarderPharmacyEditPage/OnboarderPharmacyEditPage').then((d) => d.Route)
);
